import { render, staticRenderFns } from "./BikyConfigSkillBubble.vue?vue&type=template&id=562223ce&scoped=true&"
import script from "./BikyConfigSkillBubble.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigSkillBubble.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigSkillBubble.vue?vue&type=style&index=0&id=562223ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562223ce",
  null
  
)

export default component.exports